import { BasicFrame } from 'components/organisms';
import { Countdown } from 'components';
import { frameConfigBasicTink } from '../../AppConfig';
import { SessionSavedIcon } from 'components/icons';
import { useTranslation } from 'react-i18next';
import styles from './TinkLater.module.scss';

export default function TinkLater() {
  const { t } = useTranslation('tinkLater');
  return (
    <BasicFrame {...frameConfigBasicTink} backBtnHidden headerLayout="centered">
      <div className={styles.layout} data-test="tinkLater-layout">
        <SessionSavedIcon />
        <div className={styles.title} data-test="tinkLater-title">
          {t('title')}
        </div>
        <div className={styles.content} data-test="tinkLater-content">
          {t('content')}
        </div>
        <hr className={styles['separator']} />
        <div className={styles['timer-title']} data-test="tinkLater-countTitle">
          {t('countTitle')}
        </div>
        <div className={styles['timer-wrapper']} data-test="tinkLater-timer">
          <Countdown date={new Date(Date.now() + 3 * 60 * 60 * 24 * 1000)} />
        </div>
      </div>
    </BasicFrame>
  );
}
